import React from 'react'

import Button from 'lemon-campaign-ui/lib/molecules/Button'
import { linkComponent } from '../link-children'

export default ({ component, defaults, handlers }) => {
  const clickHandler = (val, extraState) => {
    let handler = handlers.button

    handler(val, extraState, component)
  }

  const button = (
    <Button
      {...defaults}

      hasResponsiveContainer={component.content.responsive.hasContainer}
      responsiveOptions={component.content.responsive.options}

      value={component.content.value}
      text={component.content.text}
      bgColor={component.content.backgroundColor}
      color={component.content.color}
      borderRadius={component.content.borderRadius}
      align={component.content.align}
      size={component.content.size}
      buttonType={component.content.buttonType}
      animation={component.content.animation}
      draft={component.content.wysiwyg}
      bouncy

      // link={linking(component)} -- handled via js in templates/page.js

      clickHandler={clickHandler}
    />
  )

  return linkComponent(button, defaults, component.content.linking.isInternal)
}
